import React from 'react';
import { StockStatus } from 'src/types/global-types';

import { allowOnlyNumbers } from '../../../util/forms';
import { Button } from '../../Button/Button';

import classes from './ProductSizesVertical.scss';

export type Size = {
    title: string;
    id: string | number;
    maxQty: number | null;
    simpleProductId: number | null;
    simpleProductSku: string | null;
    stock?: StockStatus;
};

type ProductSizesVerticalProps = {
    size: string | number;
    sizes: Size[];
    quantity: number;
    setSize: React.Dispatch<React.SetStateAction<string | number>>;
    setQuantity: React.Dispatch<React.SetStateAction<number>>;
    onInputChange: (e: React.ChangeEvent<HTMLInputElement>, minValue: number, maxValue?: number) => void;
    stockQty: number;
};

export const ProductSizesVertical: React.FunctionComponent<ProductSizesVerticalProps> = React.memo((props) => {
    const { sizes, setSize, quantity, size, onInputChange, setQuantity, stockQty } = props;
    const onSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setSize(e.target.value);
    };

    const maxValue = sizes?.filter((s) => +s.id === +size)[0]?.maxQty || 99;

    return (
        <div className={classes.sizesVertical}>
            <select onChange={(e) => onSelectChange(e)} className={classes.sizesVerticalSelect} value={size}>
                {sizes.map((size) => {
                    return (
                        <option value={size.id} key={size.id} disabled={size.stock === 'OutOfStock'}>
                            {size.title}
                        </option>
                    );
                })}
            </select>
            <div className={classes.sizesVerticalInputAndBtns}>
                <Button
                    onClick={() => setQuantity((v) => v - 1)}
                    variant="light"
                    className={classes.sizesVerticalMinusBtn}
                    disabled={quantity <= 0}
                >
                    -
                </Button>
                <input
                    value={stockQty <= 0 ? '' : quantity}
                    onKeyPress={allowOnlyNumbers}
                    onChange={(e) => onInputChange(e, 0, maxValue)}
                    type="number"
                    disabled={stockQty <= 0}
                />
                <Button
                    onClick={() => setQuantity((v) => v + 1)}
                    variant="light"
                    className={classes.sizesVerticalPlusBtn}
                    disabled={maxValue && quantity >= maxValue}
                >
                    +
                </Button>
            </div>
        </div>
    );
});
